export default "__VITE_ASSET__6411deb1__"